import { render, staticRenderFns } from "./UserPrivacy.vue?vue&type=template&id=a32fb22c&scoped=true&"
import script from "./UserPrivacy.vue?vue&type=script&lang=ts&"
export * from "./UserPrivacy.vue?vue&type=script&lang=ts&"
import style0 from "./UserPrivacy.vue?vue&type=style&index=0&id=a32fb22c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a32fb22c",
  null
  
)

export default component.exports